/**
 * The Power and Energy preview, at `/power`: five tasks on one solar roof
 * (docs/foundations.md §8). A preview of a discipline, not the course: the
 * page says so, and its end asks whether you want the full one.
 */
import { useStrings } from '../../state/useLocale';
import { TrackPage } from '../tracks/TrackPage';
import { Disciplines } from '../foundations/Disciplines';
import { POWER_STEPS } from './steps';

export function Power() {
  const s = useStrings().power;
  return (
    <TrackPage track="power" text={s} steps={POWER_STEPS}>
      <Disciplines here="power" />
    </TrackPage>
  );
}
